import { Component, OnInit } from '@angular/core';
import { StudentService } from 'src/app/shared/student.service';
import { NgForm } from '@angular/forms';
import { AngularFirestore } from '@angular/fire/firestore';
import { ProductService } from 'src/app/shared/product.service';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html'
})
export class ProductComponent implements OnInit {

  message: string;
  constructor(private service: ProductService, private fireStore: AngularFirestore) { }

  ngOnInit() {
    this.resetForm();
  }

  resetForm(form?: NgForm) {
    if (form != null) {
      form.resetForm();
    }
    this.service.formData = {
      id: null,
      fullName: '',
      rollNo: ''
    }
  }

  onSubmit(form: NgForm) {
    // Reset the message value.
    this.message = '';

    // Making the copy of the form and assigning it to the studentData.
    let productData = Object.assign({}, form.value);

    // To avoid messing up the document id and just update the other details of the student. We will remove the 'property' from the student data.
    delete productData.id;

    // Does the insert operation.
    if (form.value.id == null) {
      this.fireStore.collection('products').add(productData);
      this.message = productData.fullName + ' information is successfully saved!';
    } else {
      // Does the update operation for the selected student.
      // The 'studentData' object has the updated details of the student.
      this.fireStore.doc('products/' + form.value.id).update(productData);
      this.message = 'Product successfully updated!';
    }

    // Reset the form if the operation is successful.
    this.resetForm(form);
  }
}
